import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import {Category, CategoryTreeNode, NodeType} from '../shared/models';
import {Router} from '@angular/router';
import {CategoryService, ChangeFiltersService, RecipeService} from '../shared/services';
import {HtmlHelper} from '@app/shared/helpers';

@Component({
  selector: 'app-category-filter',
  templateUrl: './category-filter.component.html',
  styleUrls: ['./category-filter.component.scss']
})
export class CategoryFilterComponent implements OnInit {

  categoriesTree: CategoryTreeNode[];
  categories: Category[];
  selectedCategory: CategoryTreeNode;
  previousCategory: string;
  mobileListToggleStatus = false;
  isMobile = false;
  windowWidth: number = window.innerWidth;
  statusSelectedCategory;
  selectedCategoryName;
  selectedCategoryNode;
  allowResetMenu;
  @Output() categoryFiltersAmountCheck = new EventEmitter();

  constructor(
      private router: Router,
      private categoryService: CategoryService,
      private recipeService: RecipeService,
      private changeFiltersService: ChangeFiltersService
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
  }

  ngOnInit() {
    this.categoryService.get().subscribe(x => {
      if (x !== null) {
        this.categoriesTree = this.convertToCategoryTree(x.map(y => Object.assign({}, y)));

        this.recipeService.sortHashObs.subscribe(num => {
          if (num === 4) {
            this.getNodeByHash(this.categoriesTree, this.recipeService.categoryNameHash, this.recipeService.categoryTypeHash);
            this.recipeService.pushProgressInHash('category');
          }
        });
      }
    });

    this.recipeService.getFilterState().subscribe(x => {
      if (x !== null && this.selectedCategory) {
        this.clearNodeSelect(this.selectedCategory.RecipeGroup || this.selectedCategory.SubCategory || this.selectedCategory.Category);
        this.selectedCategory = null;
        this.categoryFiltersAmountCheck.emit(this.selectedCategoryNode);
      }
    });

    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);

    this.changeFiltersService.getAllowResetRecipes().subscribe(x => {
      this.allowResetMenu = x;
    });

    this.changeFiltersService.getStateReadyMenu().subscribe(x => {
      if (this.allowResetMenu && !this.isMobile && this.selectedCategoryNode) {
        this.resetSelected(this.selectedCategoryNode);
      }
    });
  }

  getNodeByHash(tree: CategoryTreeNode[], label: string, nesting: number) {
    switch (nesting) {
      case 1:
        tree.forEach( node => {
          const isSameCategory = node.Category === this.recipeService.categoryParentNameHash &&
            node.SubCategory === this.recipeService.subCategoryNameHash;
          if (node.label === label && isSameCategory) {
            this.selectedCategory = node;
            this.selectedCategoryName = node.label;
            this.setFilterByTypeHash(node, this.recipeService.categoryTypeHash);
            this.categoryFiltersAmountCheck.emit({
              node: this.selectedCategory
            });
          }
        });
        break;
      case 2:
        tree.forEach( node => {
          this.getNodeByHash(node.children, label, nesting - 1);
        });
        break;
      case 3:
        tree.forEach( node => {
          this.getNodeByHash(node.children, label, nesting - 1);
        });
        break;
      default:
        return;
    }
  }

  setFilterByTypeHash(node: CategoryTreeNode, type: number) {
    switch (type) {
      case 3:
        node.parent.expanded = true;
        node.parent.parent.expanded = true;
        this.onRecipeGroupSelect(node);
        break;
      case 2:
        node.parent.expanded = true;
        this.onSubCategorySelect(node);
        break;
      case 1:
        this.onCategorySelect(node);
        break;
      default:
        return;
    }

    const obj = {
      node: node
    };

    this.checkSelectedNode(obj);
  }

  onNodeSelect(event) {
    this.recipeService.setSearchStatus(true);
    switch (event.node.nodeType) {
      case NodeType.Category:
        this.clearNodeSelect(event.node.Category);
        this.onCategorySelect(event.node);
        break;

      case NodeType.SubCategory:
        this.clearNodeSelect(event.node.parent.Category);
        this.onSubCategorySelect(event.node);
        break;

      case NodeType.RecipeGroup:
        this.clearNodeSelect(event.node.parent.parent.Category);
        this.onRecipeGroupSelect(event.node);
        break;

      default:
        return;
    }

    if (!this.isMobile) {
      this.getRecipesService();
    }

    const checkRedirect = this.checkCurrentLocation();
    if (checkRedirect) {
      this.router.navigateByUrl('/main/recipes/list');
    }

    this.checkSelectedNode(event);
  }

  // запрос получения данных
  getRecipesService() {
    this.recipeService.get();
    this.recipeService.getShort();
  }

  onCategorySelect(node: any) {
    node.IsSelected = true;
    this.recipeService.setFilter('category', node.Category);
    this.recipeService.setFilter('subcategory', undefined);
    this.recipeService.setFilter('recipegroup', undefined);
  }

  onSubCategorySelect(node: any) {
    node.IsSelected = true;
    node.parent.IsSelected = true;
    this.recipeService.setFilter('category', node.Category);
    this.recipeService.setFilter('subcategory', node.SubCategory);
    this.recipeService.setFilter('recipegroup', undefined);
  }

  onRecipeGroupSelect(node: any) {
    node.IsSelected = true;
    node.parent.IsSelected = true;
    node.parent.parent.IsSelected = true;
    this.recipeService.setFilter('category', node.Category);
    this.recipeService.setFilter('subcategory', node.SubCategory);
    this.recipeService.setFilter('recipegroup', node.RecipeGroup);
  }

  checkCurrentLocation(): boolean {
    // TODO: Переделать на indexOf, повторяется во всех фильтрах, следует вынести в хэлпер
    const wayForCheck = window.location.href;
    let firstPosition = (wayForCheck.length - 8);
    let stringForCheck = wayForCheck.substring(firstPosition, wayForCheck.length);
    if (stringForCheck === 'planning') {
      return false;
    }

    firstPosition = (wayForCheck.length - 7);
    stringForCheck = wayForCheck.substring(firstPosition, wayForCheck.length);
    if (stringForCheck === 'recipes') {
      return false;
    }

    firstPosition = (wayForCheck.length - 12);
    stringForCheck = wayForCheck.substring(firstPosition, wayForCheck.length);
    return !(stringForCheck === 'recipes-edit');

  }

  clearNodeSelect(category: string) {
    const categoryIndex = this.categoriesTree.findIndex(x => x.Category === this.previousCategory);
    if (categoryIndex === -1) {
      this.previousCategory = category;
      return;
    }

    this.categoriesTree[categoryIndex].IsSelected = false;
    for (let i = 0; i < this.categoriesTree[categoryIndex].children.length; i++) {
      this.categoriesTree[categoryIndex].children[i].IsSelected = false;
      for (let j = 0; j < this.categoriesTree[categoryIndex].children[i].children.length; j++) {
        this.categoriesTree[categoryIndex].children[i].children[j].IsSelected = false;
      }
    }
    this.previousCategory = category;
  }

  onNodeUnselect(event) {
    event.node.IsSelected = false;
    this.recipeService.setSearchStatus(true);
    if (event.node.parent) {
      event.node.parent.IsSelected = false;
    }
    if (event.node.parent && event.node.parent.parent) {
      event.node.parent.parent.IsSelected = false;
    }

    this.clearFilters();

    if (!this.isMobile) {
      this.getRecipesService();
    }

    this.checkSelectedNode(event);
  }

  clearFilters() {
    this.recipeService.setFilter('category', undefined);
    this.recipeService.setFilter('subcategory', undefined);
    this.recipeService.setFilter('recipegroup', undefined);
  }

  convertToCategoryTree(categories: Category[]): CategoryTreeNode[] {
    if (categories == null) {
      return null;
    }

    const categoriesTree = new Array<CategoryTreeNode>();
    const categoriesNames = [];
    categories.forEach(x => {
      if (categoriesNames.indexOf(x.CategoryName) === -1) {
        categoriesNames.push(x.CategoryName);
      }
    });
    categoriesNames.forEach(x => {
      const categoryNode = new CategoryTreeNode();
      categoryNode.Category = x;
      categoryNode.label = x;
      categoryNode.nodeType = NodeType.Category;
      const subcategories = categories.filter(y => y.CategoryName === x);
      const subCategoriesNames = [];
      subcategories.forEach(y => {
        if (subCategoriesNames.indexOf(y.SubCategoryName) === -1) {
          subCategoriesNames.push(y.SubCategoryName);
        }
      });
      subCategoriesNames.forEach(y => {
        const subcategoryNode = new CategoryTreeNode();
        subcategoryNode.nodeType = NodeType.SubCategory;
        subcategoryNode.Category = x;
        subcategoryNode.SubCategory = y;
        subcategoryNode.label = y;
        subcategoryNode.parent = categoryNode;
        const groups = subcategories.filter(z => z.SubCategoryName === y);
        groups.forEach(g => {
          const node = new CategoryTreeNode();
          node.label = g.RecipeGroup;
          node.data = g.Id_CategoryRecipe;
          node.Category = x;
          node.SubCategory = y;
          node.RecipeGroup = g.RecipeGroup;
          node.nodeType = NodeType.RecipeGroup;
          node.parent = subcategoryNode;
          subcategoryNode.children.push(node);
        });
        categoryNode.children.push(subcategoryNode);
      });

      categoriesTree.push(categoryNode);
    });

    return categoriesTree;
  }

  checkSelectedNode(event) {
    this.statusSelectedCategory = event.node['IsSelected'];
    (this.statusSelectedCategory) ? this.selectedCategoryName = event.node['label'] : this.selectedCategoryName = '';
    this.selectedCategoryNode = event;
    this.categoryFiltersAmountCheck.emit(this.selectedCategoryNode);
  }

  mobileListToggle() {
    this.mobileListToggleStatus = !this.mobileListToggleStatus;
  }

  mobileListClose() {
    this.mobileListToggleStatus = false;
  }

  resetSelected(event) {
    this.selectedCategory = null;
    this.onNodeUnselect(event);
  }

}



// WEBPACK FOOTER //
// ./src/app/category-filter/category-filter.component.ts